import React, { useEffect, useState } from "react";
import { sortingFns } from "@tanstack/react-table";
import { compareItems } from "@tanstack/match-sorter-utils";
import MasterTable from "../../../components/master/MasterTable";
import { actionPerm } from "../../../components/authNavigation/AuthNavbar";
import { format } from "date-fns";
import { sortData } from "../../../utils/sortData";
import { FaSortDown, FaSortUp } from "react-icons/fa";

const fuzzySort = (rowA, rowB, columnId) => {
  let dir = 0;

  // Only sort by rank if the column has ranking information
  if (rowA.columnFiltersMeta[columnId]) {
    dir = compareItems(
      rowA.columnFiltersMeta[columnId]?.itemRank,
      rowB.columnFiltersMeta[columnId]?.itemRank,
    );
  }

  // Provide an alphanumeric fallback for when the item ranks are equal
  return dir === 0 ? sortingFns.alphanumeric(rowA, rowB, columnId) : dir;
};

const MasterMFTable = (props) => {
  const {
    tableData,
    buttonConfig,
    setGlobalFilters,
    loading,
    actionPermissions,
    setIsFilter,
    isFilter,
    renderKey,
  } = props;

  const [tableFilter, setTableFilter] = useState(tableData);
  const [sortingType, setSortingType] = useState("asc");
  const [sortColumn, setSortColumn] = useState("scheme_name");

  useEffect(() => {
    setTableFilter(tableData);
  }, [tableData]);

  const handleSorting = (column, sortType, type) => {
    setSortColumn(column);

    const sortedData = sortData({
      data: tableData,
      column,
      type,
      sortType,
    });

    setTableFilter(sortedData);
    setSortingType(sortingType === "asc" ? "desc" : "asc");
  };

  const columns = React.useMemo(
    () => [
      {
        accessorKey: "sl",
        header: () => (
          <div className="  pl-1 text-center">
            <div>
              <div className="">SR.</div>
              <div className="">NO.</div>
            </div>{" "}
          </div>
        ),
        cell: (info) => (
          <div className=" text-center">{info.row.index + 1}.</div>
        ),
      },
      {
        accessorFn: (row) => row.amc_name,
        id: "amc_name",
        cell: (info) => info.getValue(),
        header: () => (
          <div
            onClick={() => {
              handleSorting(
                "amc_name",
                sortingType === "asc" ? "desc" : "asc",
                "string",
              );
            }}
            className=" flex  justify-between pl-1"
          >
            <div>AMC Name</div>
            <div className="space-y-[-10px]">
              <FaSortUp
                className={` ${
                  sortColumn === "amc_name" && sortingType === "asc"
                    ? "opacity-100"
                    : "opacity-50"
                }`}
              />
              <FaSortDown
                className={`${
                  sortColumn === "amc_name" && sortingType === "desc"
                    ? "opacity-100"
                    : "opacity-50"
                }`}
              />
            </div>
          </div>
        ),
        cell: (info) => <div className=""> {info.getValue()} </div>,
      },

      {
        accessorKey: "scheme_name",
        header: () => (
          <div
            onClick={() => {
              handleSorting(
                "scheme_name",
                sortingType === "asc" ? "desc" : "asc",
                "string",
              );
            }}
            className="flex w-full justify-between "
          >
            <div>SCHEME NAME</div>
            <div className="space-y-[-10px]">
              <FaSortUp
                className={` ${
                  sortColumn === "scheme_name" && sortingType === "asc"
                    ? "opacity-100"
                    : "opacity-50"
                }`}
              />
              <FaSortDown
                className={`${
                  sortColumn === "scheme_name" && sortingType === "desc"
                    ? "opacity-100"
                    : "opacity-50"
                }`}
              />
            </div>
          </div>
        ),
        cell: (info) => <div className="w-[500px]"></div>,
      },
      {
        accessorKey: "isin",
        header: () => (
          <div
            onClick={() => {
              handleSorting(
                "isin",
                sortingType === "asc" ? "desc" : "asc",
                "string",
              );
            }}
            className=" flex  justify-between "
          >
            <div>ISIN</div>
            <div className="space-y-[-10px]">
              <FaSortUp
                className={` ${
                  sortColumn === "isin" && sortingType === "asc"
                    ? "opacity-100"
                    : "opacity-50"
                }`}
              />
              <FaSortDown
                className={`${
                  sortColumn === "isin" && sortingType === "desc"
                    ? "opacity-100"
                    : "opacity-50"
                }`}
              />
            </div>
          </div>
        ),
        cell: (info) => <div className=""> {info.getValue()} </div>,
      },

      {
        accessorKey: "scheme_code",
        header: () => (
          <div
            onClick={() => {
              handleSorting(
                "scheme_code",
                sortingType === "asc" ? "desc" : "asc",
                "string",
              );
            }}
            className="flex  justify-between pl-1"
          >
            <div>
              <div className="">Scheme</div>
              <div className="">Code</div>
            </div>{" "}
            <div className="space-y-[-10px]">
              <FaSortUp
                className={` ${
                  sortColumn === "scheme_code" && sortingType === "asc"
                    ? "opacity-100"
                    : "opacity-50"
                }`}
              />
              <FaSortDown
                className={`${
                  sortColumn === "scheme_code" && sortingType === "desc"
                    ? "opacity-100"
                    : "opacity-50"
                }`}
              />
            </div>
          </div>
        ),
        cell: (info) => <div className=""> {info.getValue()} </div>,
      },

      {
        accessorKey: "scheme_type",

        header: () => (
          <div
            onClick={() => {
              handleSorting(
                "scheme_type",
                sortingType === "asc" ? "desc" : "asc",
                "string",
              );
            }}
            className=" flex  justify-between pl-1"
          >
            <div>
              <div className="">Scheme</div>
              <div className="">Type</div>
            </div>{" "}
            <div className="space-y-[-10px]">
              <FaSortUp
                className={` ${
                  sortColumn === "scheme_type" && sortingType === "asc"
                    ? "opacity-100"
                    : "opacity-50"
                }`}
              />
              <FaSortDown
                className={`${
                  sortColumn === "scheme_type" && sortingType === "desc"
                    ? "opacity-100"
                    : "opacity-50"
                }`}
              />
            </div>
          </div>
        ),
        cell: (info) => <div className=""> {info.getValue()} </div>,
      },

      {
        accessorKey: "scheme_plan",
        header: () => (
          <div
            onClick={() => {
              handleSorting(
                "scheme_plan",
                sortingType === "asc" ? "desc" : "asc",
                "string",
              );
            }}
            className=" flex  justify-between pl-1"
          >
            <div>
              <div className="">Scheme</div>
              <div className="">Plan</div>
            </div>{" "}
            <div className="space-y-[-10px]">
              <FaSortUp
                className={` ${
                  sortColumn === "scheme_plan" && sortingType === "asc"
                    ? "opacity-100"
                    : "opacity-50"
                }`}
              />
              <FaSortDown
                className={`${
                  sortColumn === "scheme_plan" && sortingType === "desc"
                    ? "opacity-100"
                    : "opacity-50"
                }`}
              />
            </div>
          </div>
        ),
        cell: (info) => <div className=""> {info.getValue()} </div>,
      },
      {
        accessorKey: "rta_agent_code",
        header: () => (
          <div
            onClick={() => {
              handleSorting(
                "rta_agent_code",
                sortingType === "asc" ? "desc" : "asc",
                "string",
              );
            }}
            className=" flex justify-between pl-1"
          >
            <div>
              <div className="">RTA Agent</div>
              <div className="">Code</div>
            </div>{" "}
            <div className="space-y-[-10px]">
              <FaSortUp
                className={` ${
                  sortColumn === "rta_agent_code" && sortingType === "asc"
                    ? "opacity-100"
                    : "opacity-50"
                }`}
              />
              <FaSortDown
                className={`${
                  sortColumn === "rta_agent_code" && sortingType === "desc"
                    ? "opacity-100"
                    : "opacity-50"
                }`}
              />
            </div>
          </div>
        ),
        cell: (info) => <div className=""> {info.getValue()} </div>,
      },
      {
        accessorKey: "status",
        header: () => <div className="pl-1 text-center">STATUS</div>,
        cell: (info) => <div className=" text-center"> {info.getValue()} </div>,
      },
    ],
    [sortColumn, sortingType, tableData, tableFilter],
  );

  const action = actionPerm(actionPermissions);

  return (
    <MasterTable
      columns={columns}
      tableData={tableFilter?.length > 0 ? tableFilter : tableData}
      buttonConfig={buttonConfig}
      renderKey={renderKey}
      loading={loading}
      filterField
      setGlobalFilters={setGlobalFilters}
      actions={action}
      setIsFilter={setIsFilter}
      isFilter={isFilter}
      name="MutualFund"
    />
  );
};

export default MasterMFTable;
